import React, { FC } from 'react';

import { connect } from 'react-redux';

import { LOANFORMAT_ALL_OBJECT } from '../../store/loanFormat/actions';
import ForeignLanguageSubNavigation from './ForeignLanguageSubNavigation';
import { LoanFormatState } from '../../store/loanFormat/state';
import { AppState } from '../../store/appState';
import { LanguageScope, useLanguages } from '../../shop/language/useLanguages';
import { mapLoanFormat } from '../../../models/LoanFormat';

type OwnProps = {
    readonly isSticky: boolean;
};

type Props = {
    readonly loanFormat: LoanFormatState;
    readonly selectedLanguage: string | null;
};

const LoteNavigation: FC<Props & OwnProps> = ({ isSticky, loanFormat: loanFormatState, selectedLanguage }) => {
    const loanFormat = mapLoanFormat(loanFormatState.requestKey);
    const { languages } = useLanguages({ scope: LanguageScope.LOTE, loanFormat, shopLanguage: undefined });

    return (
        <ForeignLanguageSubNavigation
            isSticky={isSticky}
            loanFormat={loanFormatState}
            selectedLanguage={selectedLanguage}
            languages={languages}
        />
    );
};

function mapStateToProps(state: AppState): Props {
    return {
        loanFormat: state.loanFormat || LOANFORMAT_ALL_OBJECT,
        selectedLanguage: state.foreignLanguage.selectedLanguage
    };
}

export default connect(mapStateToProps)(LoteNavigation);
